/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Waterecsconsumption2Inputs */



/**
* | output |
* | --- |
* | "Cold water consumption used for domestic hot water" |
*
* @param {Br_History_Key_Waterecsconsumption2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_waterecsconsumption2 = /** @type {((inputs?: Br_History_Key_Waterecsconsumption2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Waterecsconsumption2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Cold water consumption used for domestic hot water")
	return /** @type {LocalizedString} */ ("Consommation d'eau froide utilisée par l'eau chaude sanitaire")
});
export { br_history_key_waterecsconsumption2 as "br_history_key_waterEcsConsumption" }